import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const CHUNK_RELOAD_KEY = "ss:chunk-reload-attempted";
const CHUNK_FAILURE_PATTERNS = [
  /ChunkLoadError/i,
  /Loading chunk [\w-]+ failed/i,
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /error loading dynamically imported module/i,
  /text\/html.*valid JavaScript MIME type/i,
];

function isChunkLoadFailure(value: unknown): boolean {
  const message =
    typeof value === "string"
      ? value
      : value instanceof Error
        ? `${value.name}: ${value.message}`
        : typeof value === "object" && value !== null && "message" in value
          ? String((value as { message?: unknown }).message ?? "")
          : "";

  return CHUNK_FAILURE_PATTERNS.some((pattern) => pattern.test(message));
}

function reloadOnceForChunkFailure(): void {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === "true") {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    return;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
  window.location.reload();
}

window.addEventListener("load", () => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  reloadOnceForChunkFailure();
});

window.addEventListener("unhandledrejection", (event) => {
  if (!isChunkLoadFailure(event.reason)) {
    return;
  }

  event.preventDefault();
  reloadOnceForChunkFailure();
});

window.addEventListener("error", (event) => {
  if (!isChunkLoadFailure(event.error ?? event.message)) {
    return;
  }

  reloadOnceForChunkFailure();
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
